import Button from './Button';

export type { ButtonProps } from './Button';
export * from './Button.theme';

export default Button;
